import { Button } from '@/components/ui/button'
import { useTheme } from '@/components/ThemeProvider'

const NoBlockSelected = ({ addBlock }) => {
  const { resolvedTheme } = useTheme()

  return (
    <div className='flex flex-col items-center justify-center p-10 h-full'>
      <Choose>
        <When condition={resolvedTheme === 'dark'}>
          <img src='/blocks-dark.svg' alt='Blocks' className='w-[200px] self-center mb-5' />
        </When>

        <Otherwise>
          <img src='/blocks.svg' alt='Blocks' className='w-[200px] self-center mb-5' />
        </Otherwise>
      </Choose>
      <h4 className='text-2xl font-semibold'>Add a block to get started</h4>
      <Button className='mt-5' onClick={addBlock}>
       
        Add block
      </Button>
    </div>
  )
}

export default NoBlockSelected
